import { api } from "..";
import { IUser } from "../../types";

// funcao para fazer login
const LoginService = async (data: IUser) => {

    const response = await api.post('auth/login', data);

    return response;

}
// funcao para fazer login

// funcao para pesquisar usuário logado
const MeService = async () => {

    const response = await api.get('auth/me');

    return response;

}
// funcao para pesquisar usuário logado

// funcao para fazer logout
const LogoutService = async () => {

    const response = await api.post('auth/logout');

    return response;

}
// funcao para fazer logout

// função para o usuário alterar sua senha
const AuthChangePasswordService = async (password: string, newPassword: string) => {

    const response = await api.post('auth/password', {
        password, newPassword
    });

    return response;

}
// função para o usuário alterar sua senha

export {
    LoginService,
    MeService,
    LogoutService,
    AuthChangePasswordService
}